module.exports = __webpack_public_path__ + "static/media/upload_more.8a88621c.svg";